import React, { FunctionComponent } from "react";
import { Select } from "antd";
import "./index.scss";

type Props = {
  title: string;
  options: Array<{ label: string; value: string }>;
  defaultValue: string | null;
  onChange: (selectedValue: string) => void;
  isOptionsLoading?: boolean;
  placeholder: string;
};

export const FilterDropdown: FunctionComponent<Props> = (props: Props) => {
  return (
    <div className={"FilterDropdown"}>
      <div className={"label"}>{props.title}</div>
      <div className={"option"}>
        <Select
          className={"authz-select"}
          value={props.defaultValue}
          options={props.options}
          onChange={props.onChange}
          placeholder={props.placeholder}
          dropdownMatchSelectWidth={false}
          allowClear={true}
        />
      </div>
    </div>
  );
};
